module.exports = __webpack_public_path__ + "static/media/Brownies.46b120d6.jpg";